<template>
  <div class="accordion">
    <div
      class="accordion__button"
      :class="{ active: isOpen }"
      role="button"
      @click="open"
    >
      <div class="accordion__title">
        <span class="icon-information"></span>
        <p class="accordion__title-text">
          {{ store.translations.AccordionTitle }}
        </p>
        <span class="icon-arrow-new-down"></span>
      </div>
      <div
        class="accordion__content"
        :class="{ active: isOpen }"
        v-if="isOpen"
      >

        <div class="accordion__content-text" :class="{ active: isOpen }">
          <div class="accordion__help-text--bold">
            {{ store.translations.TargetPopulation }}:&nbsp; <span class="accordion__help-text">{{ store.translations.TargetPopulationHelpText}}</span>
          </div>
        </div>
        
        <div class="accordion__content-text" :class="{ active: isOpen }">
          <div class="accordion__help-text--bold">
            {{ store.translations.ActualSeedRate }}:&nbsp; <span class="accordion__help-text">{{ store.translations.ActualSeedRateHelpText}}</span>
          </div>
        </div>
        
        <div class="accordion__content-text" :class="{ active: isOpen }">
          <div class="accordion__help-text--bold">
            {{ store.translations.ThousandGrainWeight }}:&nbsp; <span class="accordion__help-text">{{ store.translations.ThousandGrainWeightHelpText}}</span>
          </div>
        </div>
        
        <div class="accordion__content-text" :class="{ active: isOpen }">
          <div class="accordion__help-text--bold">
            {{ store.translations.GerminationRate }}:&nbsp; <span class="accordion__help-text">{{ store.translations.GerminationRateHelpText}}</span>
          </div>
        </div>
        
        <div class="accordion__content-text" :class="{ active: isOpen }">
          <div class="accordion__help-text--bold">
            {{ store.translations.FieldGerminationRate }}:&nbsp; <span class="accordion__help-text">{{ store.translations.FieldLossesHelpText}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useSeedRateCalculatorStore } from '../store/store.js';

const store = useSeedRateCalculatorStore();

const isOpen = ref(false);

const open = () => {
  isOpen.value = !isOpen.value;
};
</script>